var exports = {
  "qI": "listContainer__LpSRDx",
  "uC": "listItemHeading__phux55",
  "l5": "hiddenListItemTitleTooltip__gHooSU",
  "Z7": "listItemTitleTooltip__2R1CWi",
  "MT": "listItemDescription__Kkz86c",
  "Qi": "listItemDescriptionTruncate__vdcehI",
};

module.exports = exports;
